import {  renderMultiselect } from "../../common/renderinput";
import { Field, reduxForm } from "redux-form";
import React, { Component } from "react";
const p = [ 
    'Product 1' ,
    'Product 2' ,
    'Product 3' ,
    // { value: '4', label: 'Product 4' },
    // { value: '5', label: 'Product 5' },
    // { value: '6', label: 'Product 6' },
    // { value: '7', label: 'Product 7' },
    // { value: '8', label: 'Product 8' },
    // { value: '9', label: 'Product 9' },
    // { value: '10', label: 'Product 10' },
    // { value: '11', label: 'Product 11' },
    // { value: '12', label: 'Product 12' },
    
]


class Product extends Component {
  render() {
    return (
        <>
        <div className="container-fluid">
        <div className="row">
            <div className="form-group col-12">
              <span>Select Product(s)</span>		
            </div>
          </div>
          <div className="row">
            <div className="form-group col-4">
            <Field
                    name="Title"
                    component={renderMultiselect}
                    defaultValue={[]}   
                    // disabled={!props.Role.role.includes('Admin')}
                    data={p}
                  />

            </div>
          </div>

        </div>
      </>
    );
  }
}
export default  Product;